import React from 'react'
import { Helmet } from 'react-helmet'

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keywords' content={keywords} />
    </Helmet>
  )
}

Meta.defaultProps = {
  title: 'Welcome to ExoAdvances',
  description: 'We offer products and services to advance exosome research',
  keywords: 'exosomes, extracellular vesicles, EVs',
}

export default Meta
